import React, { useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/styles';
import {
    Typography,
    Badge
} from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';

import { FolderPrivate, FolderPublic } from '../Icons';
import ProjectMenu from './ProjectMenu';

const useStyles = makeStyles((theme) => styles(theme));

const propTypes = {
    project: PropTypes.object.isRequired,
    isOwner: PropTypes.bool.isRequired,
    isCurrentProject: PropTypes.bool.isRequired,
    isSelectedProject: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired, 
    onEditClick: PropTypes.func.isRequired, 
    onDeleteClick: PropTypes.func.isRequired
};

const defaultProps = {

};


function ProjectItem ({project, isOwner, isCurrentProject, isSelectedProject, onClick, onEditClick, onDeleteClick}) {
    const classes = useStyles();
    const [isHovering, setIsHovering] = useState(false);

    return (
        <div
            className={classNames(classes.root, (isCurrentProject || isSelectedProject) && classes.selected)} 
            onClick={() => onClick(project.id)}
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)}
        >
            <div className={classes.iconContainer}>
                <Badge
                    classes={{ root: classes.selectedBadge }}
                    color="secondary"
                    overlap="circular"
                    badgeContent={<CheckIcon />}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right'
                    }}
                    invisible={!isCurrentProject}
                >
                    { project.isPrivate ? <FolderPrivate /> : <FolderPublic /> }
                </Badge>
                { Boolean(isOwner && isHovering) && (
                    <ProjectMenu
                        setEditProject={() => onEditClick(project.id)}
                        setDeleteProject={() => onDeleteClick(project.id)}
                    />
                )}
            </div>
            <div className={classes.footer}>
                <Typography
                    variant="subtitle1"
                >
                    {project.name}
                </Typography>
                <Typography
                    variant="caption"
                >
                    {project.numSiteCards} Sites  •  { project.isPrivate ? 'Private' : 'Shared' }
                </Typography>
            </div>
        </div>
    );
    
}

const styles = theme => ({
    root: {
        border: `1px solid ${theme.palette.grey.variant3}`,
        width: '170px',
        height: '170px',
        margin: '1px',
        borderRadius: theme.constants.radius.sm,
        display: 'flex',
        flexDirection: 'column',
        cursor: 'pointer'
    },
    selected: {
        border: `2px solid ${theme.palette.primary.light}`,
        margin: '0 !important'
    },
    iconContainer: {
        flexGrow: 1,
        display: 'grid',
        placeItems: 'center',
        position: 'relative'
    },
    footer: {
        padding: '15px 15px 10px 15px',
        display: 'flex',
        flexDirection: 'column',
        rowGap: '5px',
        borderTop: `1px solid ${theme.palette.grey.variant3}`
    },
    selectedBadge: {
        '& > .MuiBadge-badge': {
            height: '30px',
            width: '30px',
            borderRadius: '50%'
        }
    }
});

ProjectItem.propTypes = propTypes;
ProjectItem.defaultProps = defaultProps;

export default ProjectItem;